import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFinalMarkDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M1.50191 1.50191C0.363346 2.64047 -0.636654 4.36335 0.50191 5.50191C1.64047 6.64047 3.36335 5.64047 4.50191 4.50191C5.64047 3.36335 6.64047 1.64047 5.50191 0.50191C4.36335 -0.636654 2.64047 0.363346 1.50191 1.50191Z",
			fill: "#43454A"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.092 3.83182C0.923084 4.31516 0.996934 4.58272 1.20902 4.7948C1.4211 5.00689 1.68866 5.08074 2.172 4.91182C2.69109 4.73041 3.28184 4.30776 3.7948 3.7948C4.30776 3.28184 4.73041 2.69109 4.91182 2.172C5.08074 1.68866 5.00689 1.4211 4.7948 1.20902C4.58272 0.996934 4.31516 0.923084 3.83182 1.092C3.31273 1.27341 2.72198 1.69606 2.20902 2.20902C1.69606 2.72198 1.27341 3.31273 1.092 3.83182ZM0.50191 5.50191C-0.636654 4.36335 0.363346 2.64047 1.50191 1.50191C2.64047 0.363346 4.36335 -0.636654 5.50191 0.50191C6.64047 1.64047 5.64047 3.36335 4.50191 4.50191C3.36335 5.64047 1.64047 6.64047 0.50191 5.50191Z",
			fill: "#CED0D6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.55078 5.80147L6.22262 6.91602C6.42093 7.04823 6.68499 7.02208 6.85352 6.85355C7.02205 6.68502 7.0482 6.42096 6.91599 6.22265L5.80144 4.55081C5.60928 4.78882 5.40799 5.0097 5.20883 5.20886C5.00967 5.40802 4.78879 5.60931 4.55078 5.80147Z",
			fill: "#CED0D6"
		})
	]
});
export default SvgFinalMarkDark;
